export default function (wrappers) {
    wrappers.forEach(function (wrapper) {
        let advWrapper = document.querySelectorAll('[id^=' + wrapper +']');
        for (let element of advWrapper) {
            element.remove();
        }
    })
}